module.exports = __webpack_public_path__ + "static/kulturwerke-padded-73c38cebe7cd61863bc95a9b049ca17a.jpeg";